<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
        <div class="header">
          <h3
            v-if="isGroupMode"
            class="md-headline"
          >
            {{ groupData.name || '' }} Promocodes
          </h3>
          <h3
            v-else
            class="md-headline"
          >
            Promocodes
          </h3>

          <div>
            <md-button
              v-if="downloadCSVButton.isShown"
              class="md-primary"
              @click="downloadAsCSV"
            >
              <md-progress-spinner
                v-if="downloadCSVButton.isLoading"
                class="md-accent"
                :md-stroke="3"
                md-mode="indeterminate"
                :md-diameter="17"
              />
              <span v-else>Download CSV</span>
            </md-button>
            <md-button
              v-if="isGroupMode"
              @click="dialog.active = true"
            >
              Edit group
            </md-button>
            <md-button
              v-if="isGroupMode"
              class="deleteButton"
              @click="deleteDialog.isOpen = true"
            >
              Delete group
            </md-button>
            <md-button
              v-else
              class="md-primary"
              @click="displayDialog(false)"
            >
              Add
            </md-button>
          </div>
        </div>

        <div v-if="!isGroupMode">
          <md-switch
            v-model="filter.hideGroupCodes"
            @change="onNoGroupFilterChange"
          >
            Hide codes from groups
          </md-switch>
        </div>

        <v-server-table
          ref="table"
          url="/people"
          :columns="table.columns"
          :options="table.options"
          class="shortcut-table"
        >
          <template #code="props">
            <a
              style="text-decoration: underline; padding: 6px 3px; text-align: left; display: block;"
              @click="displayDialog(props.row)"
            >
              {{ props.row.code }}
            </a>
          </template>

          <template #starts_from="props">
            {{ new Date(props.row.starts_from).toLocaleDateString('ua') }}
          </template>

          <template #valid_until="props">
            {{ new Date(props.row.valid_until).toLocaleDateString('ua') }}
          </template>

          <template #allowed="props">
            {{ props.row.isRedeemAllowed }}
          </template>

          <template #max_redeems="props">
            {{ props.row.total_redeemable_number }}
          </template>

          <template #redeemed="props">
            {{ props.row.total_redeemed_count }}
          </template>

          <template #per_account="props">
            {{ props.row.maximum_redeem_times }}
          </template>

          <template #premium_hours="props">
            {{ props.row.premium_duration_hours }}
          </template>
        </v-server-table>
      </div>
    </div>

    <EditPromocode
      :active="showDialog"
      :promocode="activeCode"
      @dialogClosed="onDialogClose"
    />

    <promocode-group-dialog
      :dialog="dialog"
      :edit-mode="true"
      @submit="onEditGroupSubmit"
    />

    <md-dialog-confirm
      :md-active.sync="deleteDialog.isOpen"
      :md-title="isGroupMode ? `Delete promocode group '${groupData.name}'?` : ''"
      md-confirm-text="Delete"
      md-cancel-text="Cancel"
      @md-cancel="deleteDialog.isOpen = false"
      @md-confirm="deletePromocodeGroup"
    />
  </div>
</template>

<script>
import EditPromocode from "@/pages/EditPromocode";
import PromocodeGroupDialog from "../components/Forms/PromocodeGroupDialog";
import {Event} from "vue-tables-2-premium";

export default {
    name: "PromocodesPage",
    components: {EditPromocode, PromocodeGroupDialog},
    data() {
        const group = this.$route.params.group;

        return {
            isGroupMode: !!group,
            groupId: group,
            groupData: {},

            promocodes: [],

            showDialog: false,
            activeCode: false,

            dialog: this.getDefaultDialogState(),
            deleteDialog: {
                isOpen: false,
            },

            downloadCSVButton: {
                isShown: !!group,
                isLoading: false
            },

            filter: {
                hideGroupCodes: !group,
            },

            table: {
                columns: [
                    "code", "starts_from", "valid_until", "allowed", "max_redeems", "redeemed", "per_account", "premium_hours"
                ],
                options: {
                    perPage: 100,
                    filterByColumn: true,
                    filterable: ["code"],
                    sortable: [
                        "code", "starts_from", "valid_until", "allowed", "max_redeems", "redeemed", "per_account", "premium_hours"
                    ],
                    sendInitialRequest: false,
                    customFilters: ["hideGroupCodes"],
                    requestFunction: (data) => {
                        console.log(data);

                        const params = new URLSearchParams();
                        params.append("offset", data.limit * (data.page - 1));

                        if (data.orderBy) {
                            params.append("sortBy", data.orderBy);
                        }

                        if (data.query.code) {
                            params.append("code", data.query.code);
                        }

                        if (data.hideGroupCodes && !this.isGroupMode) {
                            params.append("not_group", "active");
                        }

                        if (this.isGroupMode) {
                            params.append("group_id", this.groupId);
                        }

                        return this.$http.get(`/v1/admin/store/promocodes?${params}`);
                    },
                    responseAdapter: (res) => {
                        if (this.isGroupMode) {
                            const promocodes = res.data.promocodes;

                            this.dialog.form = {...promocodes[0]};
                            delete this.dialog.form.id;
                            delete this.dialog.form.code;
                            this.dialog.form.group = this.groupId;
                            this.dialog.premiumDurationDays = promocodes[0].premium_duration_hours / 24;
                            this.dialog.durationHelperText = promocodes[0].premium_duration_hours + " hours";
                        }

                        return { data: res.data.promocodes, count: res.data.totalPromocodes };
                    }
                }
            },
        };
    },
    mounted() {
        this.$refs.table.setCustomFilters({ hideGroupCodes: this.filter.hideGroupCodes });
        this.fetchGroupData();
    },
    methods: {
        displayDialog(code) {
            this.activeCode = code;
            this.showDialog = true;
        },
        onDialogClose({shouldRefresh}) {
            this.showDialog = false;
            if (shouldRefresh) {
                window.location.reload();
            }
        },
        async downloadAsCSV() {
            if (!this.isGroupMode) {
              return;
            }
            this.downloadCSVButton.isLoading = true;

            let promocodesText = "code";

            const params = new URLSearchParams();
            params.append("group_id", this.groupId);

            const perPage = 100;
            let offsetCounter = 0;

            let response = null;
            while (true) {
              try {
                response = await this.$http.get(`/v1/admin/store/promocodes?${params}&offset=${perPage * offsetCounter}`)
                  .then((r) => r.data.promocodes);
              } catch (e) {
                this.$notify({
                    group: "foo",
                    title: "Error loading codes fro CSV",
                });
                this.downloadCSVButton.isLoading = false;
                return;
              }

              console.log("response", response);

              promocodesText += response.reduce((acc, cur) => acc + "\n" + cur.code, "");
              offsetCounter++;
              if (response.length < perPage) {
                break;
              }
            }

            const element = document.createElement("a");
            element.setAttribute("href", "data:text/plain;charset=utf-8," + encodeURIComponent(promocodesText));
            element.setAttribute("download", this.groupData.name + ".csv");

            element.style.display = "none";
            document.body.appendChild(element);

            element.click();

            document.body.removeChild(element);
            this.downloadCSVButton.isLoading = false;
        },
        fetchGroupData() {
            this.$http.get(`/v1/admin/store/promocode/groups?group_id=${this.groupId}`).then(res => {
                this.groupData = res.data.groups[0];
            });
        },
        onEditGroupSubmit(form) {
            this.$http.post("/v1/admin/store/promocode/group/update", form)
                .then(() => {
                    this.dialog = this.getDefaultDialogState();
                    this.$notify({
                        group: "foo",
                        title: "Promocode group updated",
                    });
                    window.location.reload();
                })
                .catch((err) => {
                    console.error("Couldn’t update a promocode group:", err);
                    this.dialog.isSubmitting = false;
                });
        },
        getDefaultDialogState() {
            return {
                active: false,
                premiumDurationDays: 1,
                durationHelperText: "24 hours",
                isSubmitting: false,

                form: {
                    group: "",
                    count: "0",
                    starts_from: "",
                    valid_until: "",
                    isRedeemAllowed: true,
                    can_be_summed: false,
                    maximum_redeem_times: "1",
                    premium_duration_hours: "24"
                }
            };
        },
        deletePromocodeGroup() {
            this.$http.delete(`/v1/admin/store/promocode/group/${this.groupData.id}`)
                .then(() => {
                    this.$notify({
                        group: "foo",
                        title: "Promocode group deleted",
                    });
                    window.location.href = "/promocodes/groups";
                })
                .catch(e => {
                    console.error("Couldn’t delete a promocode group:", e);
                    this.$notify({
                        group: "foo",
                        title: "Error -- failed to delete group: " + e,
                    });
                });
        },
        onNoGroupFilterChange() {
            Event.$emit("vue-tables.filter::hideGroupCodes", this.filter.hideGroupCodes);
        },
    }
};
</script>

<style scoped lang="scss">
.header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 30px;
}

.deleteButton {
    background: #ff5252 !important;
}
</style>
